var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column"},[_c('el-card',[_c('el-button',{on:{"click":_vm.newInstrumentType}},[_vm._v(" 新增儀器類型 ")]),_c('el-button',{on:{"click":_vm.uploadInstrumentType}},[_vm._v(" 上傳儀器類型 ")])],1),_c('el-card',[_c('hot-table',{ref:"hot",attrs:{"id":"hot-container","root":"hot","settings":_vm.settings}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }